import * as React from "react";
import { useId } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDate = (props) => {
	const __svgrId = useId();
	return /* @__PURE__ */ _jsx("svg", {
		fill: "none",
		viewBox: "0 0 32 32",
		xmlns: "http://www.w3.org/2000/svg",
		...props,
		children: /* @__PURE__ */ _jsxs("g", {
			transform: "translate(0.4848 0) scale(0.9697)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M16.0001 27.0003 C22.6275 27.0004 28.0001 21.6278 28 15.0003 C28.0001 8.3729 22.6274 3.0004 16 3.0004 C9.3726 3.0004 4 8.3729 4 15.0004 C4 21.6278 9.3726 27.0004 16.0001 27.0003 Z",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 5.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.0001 27.0003 C22.6275 27.0004 28.0001 21.6278 28 15.0003 C28.0001 8.3729 22.6274 3.0004 16 3.0004 C9.3726 3.0004 4 8.3729 4 15.0004 C4 21.6278 9.3726 27.0004 16.0001 27.0003 Z",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5,
					style: {
						fill: "var(--sticker-pastel,#FFC98E)",
						stroke: "var(--sticker-dark,#9A6528)"
					}
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M22.7513 15.9788 L15.4516 15.9788 L15.4516 8.6819",
					strokeLinecap: "round",
					strokeLinejoin: "round",
					strokeWidth: 1.5,
					style: { stroke: "var(--sticker-dark,#9A6528)" }
				})
			]
		})
	});
};
export default SvgDate;
